var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "fallback-card ia-block-card",
      attrs: {
        "data-cartao": "fallback",
        role: "group",
        "aria-label": _vm.titulo
      }
    },
    [
      _c("CartaoCabecalho", {
        attrs: {
          titulo: _vm.titulo,
          icone: "error-circle",
          "cor-do-icone": "primary",
          fita: "",
          compacto: ""
        }
      }),
      _c("div", { staticClass: "ia-block-card__corpo" }, [
        _c(
          "p",
          {
            staticClass:
              "fallback-card__detalhe az-text-primary az-size-12 az-muted mb-0",
            attrs: { "data-teste": "detalhe" }
          },
          [
            _c(
              "span",
              { staticClass: "fallback-card__identificacao ia-texto-mono" },
              [_vm._v(_vm._s(_vm.identificacao))]
            ),
            _vm._v(" · " + _vm._s(_vm.motivoHumano))
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }